import { render, staticRenderFns } from "./baoyou1.vue?vue&type=template&id=7b3b6326&scoped=true"
var script = {}
import style0 from "./baoyou1.vue?vue&type=style&index=0&id=7b3b6326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3b6326",
  null
  
)

export default component.exports